import { useEffect, useRef, useState } from "react";
import Button from "../UI/Button";
import { useDispatch } from "react-redux";
import { sendMessage } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

var storageRef = firebase.storage().ref();

export default function NewsLetter() {
  const [messages, setMessages] = useState({
    title: "",
    description: "",
    titleTyped: "",
    descriptionTyped: "",
    eventDate: ""
  });
  
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();

  // Fetch previous newsletter data
  const fetchNewsLetterData = async () => {
    try {
      const db = firebase.firestore();
      const newsLetterDoc = await db.collection('Game_Config').doc("GameData").get();
      const newsLetterData = newsLetterDoc.data();

      if (newsLetterData) {
        setMessages((prev) => ({
          ...prev,
          title: newsLetterData?.News_Heading || "",
          description: newsLetterData?.News_Description || "",
          titleTyped: "",
          descriptionTyped: "",
          eventDate: ""
        }));
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching document: ", error);
    }
  };

  useEffect(() => {
    fetchNewsLetterData();
  }, []);

  const getMessages = (e: any) => {
    const { name, value } = e.target;
    const createdAt = new Date().getTime();
    const updatedAt = new Date().getTime();

    setMessages((prev) => ({
      ...prev,
      [name]: value,
      createdAt,
      updatedAt
    }));
  };

  const resetForm = () => {
    setMessages((prev) => ({
      ...prev,
      titleTyped: "",
      descriptionTyped: "",
      eventDate: ""
    }));

    setSuccess("Newsletter added successfully");
    setError("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    fetchNewsLetterData()
    setTimeout(() => {
      setSuccess("");
    }, 4000);
    
  };

  const saveMessage = async (e: any) => {
    e.preventDefault();
    const { file, eventDate } = e.target;
    let isValid = true;

    const { titleTyped, descriptionTyped } = messages;

    if (!descriptionTyped.trim()) {
      setError("Please enter the description.");
      isValid = false;
    } else if (!titleTyped.trim()) {
      setError("Please enter the title.");
      isValid = false;
    } else if (!eventDate.value) {
      setError("Please select a date.");
      isValid = false;
    } else if (file.files.length === 0) {
      setError("Please select an image with width 900px.");
      isValid = false;
    }

    if (
      descriptionTyped.trim().length <= 10 ||
      titleTyped.trim().length < 10 ||
      titleTyped.trim().length > 30
    ) {
      setError(
        "Title must be 10–30 characters. Description must be more than 10 characters."
      );
      isValid = false;
    }

    if (isValid) {
      const fileToUpload = file.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(fileToUpload);

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = async () => {
          if (img.width !== 900) {
            setError("Please select image with width 900px.");
            setSuccess("")
            return;
          }
          
          const fileRef = storageRef.child("newsletter");
          await uploadBytes(fileRef, fileToUpload);
          const fileUrl = await getDownloadURL(fileRef);
          
          const messageData = {
            title: titleTyped,
            description: descriptionTyped,
            eventDate: eventDate.value,
            file: fileUrl
          };
          
          dispatch(sendMessage(messageData));
          resetForm();
        };
      };
    }
  };

  return (
    <main>
      <div className="container-fluid px-4">
        <h1>Add a Newsletter</h1>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={saveMessage}>
              <div className="form-row">
                Newsletter Title
                <input
                  type="text"
                  className="form-control"
                  style={{ color: "black" }}
                  name="titleTyped"
                  value={messages.titleTyped}
                  placeholder={messages.title}
                  onChange={getMessages}
                />
              </div>

              <div className="form-row">
                Select an image for Newsletter
                <input
                  type="file"
                  className="form-control"
                  name="file"
                  ref={fileInputRef}

                />
              </div>

              <div className="form-row">
                Date
                <input
                  type="date"
                  className="form-control"
                  style={{ color: "black" }}
                  name="eventDate"
                  value={messages.eventDate}
                  onChange={getMessages}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="form-row">
                Description
                <textarea
                  className="form-control"
                  style={{ lineHeight: "normal", padding: "1.5%", color: "black" }}
                  name="descriptionTyped"
                  value={messages.descriptionTyped}
                  placeholder={messages.description}
                  onChange={getMessages}
                />
              </div>

              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}

              <Button text="Submit Newsletter" className="btn btn-primary btn-lg" />
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
